export const AUTH_ERROR_MESSAGE = {
    UserNotAuthenticated: 'User is not logged in'
};
